//option one

// import React, { useState, useEffect } from "react";
// import { FiChevronRight, FiChevronLeft } from "react-icons/fi";
// import { FaQuoteRight } from "react-icons/fa";
// import { CSSTransition } from "react-transition-group";
// import data from "./data";

// function Slider() {
//   const [reviews, setReviews] = useState(data);
//   const [currentIndex, setCurrentIndex] = useState(0);

//   function handlePrev() {
//     if (currentIndex === 0) {
//       setCurrentIndex(data.length - 1);
//     } else {
//       setCurrentIndex(currentIndex - 1);
//     }
//   }

//   function handleNext() {
//     if (currentIndex === data.length - 1) {
//       setCurrentIndex(0);
//     } else {
//       setCurrentIndex(currentIndex + 1);
//     }
//   }

//   function renderSlide() {
//     const slide = data[currentIndex];
//     return (
//       <div>
//         <h2>{slide.title}</h2>
//         <p>{slide.description}</p>
//         <img src={slide.image} alt={slide.title} />
//       </div>
//     );
//   }

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentIndex((currentIndex) => (currentIndex + 1) % data.length);
//     }, 2000);
//     return () => clearInterval(interval);
//   }, [currentIndex]);

//   return (
//     <section className="section">
//       <div className="section-center">
//         {data.map((slide, index) => (
//           <CSSTransition
//             key={slide.id}
//             in={currentIndex === index}
//             timeout={300}
//             classNames="slide"
//             mountOnEnter
//             unmountOnExit
//           >
//             <article className="slides">
//               <img src={slide.image} alt={slide.title} className="person-img" />
//               <h4>{slide.name}</h4>
//               <p className="title">{slide.title}</p>
//               <p className="text">{slide.quote}</p>
//               <FaQuoteRight className="icon" />
//             </article>
//           </CSSTransition>
//         ))}

//         <button className="prev" onClick={handlePrev}>
//           <FiChevronLeft />
//         </button>
//         <button className="next" onClick={handleNext}>
//           <FiChevronRight />
//         </button>
//       </div>
//     </section>
//   );
// }

// export default Slider;

//Option two
import React, { useState, useEffect } from "react";
import { FiChevronRight, FiChevronLeft } from "react-icons/fi";
import { FaQuoteRight } from "react-icons/fa";
import data from "./data";
function App() {
  const [people, setPeople] = useState(data);
  const [index, setIndex] = React.useState(0);

  useEffect(() => {
    const lastIndex = people.length - 1;
    if (index < 0) {
      setIndex(lastIndex);
    }
    if (index > lastIndex) {
      setIndex(0);
    }
  }, [index, people]);

  useEffect(() => {
    let slider = setInterval(() => {
      setIndex(index + 1);
    }, 5000);
    return () => {
      clearInterval(slider);
    };
  }, [index]);

  return (
    <section className="section">
      <div className="title">
        <h2>
          <span>/</span>reviews
        </h2>
      </div>
      <div className="section-center">
        {people.map((person, personIndex) => {
          const { id, image, name, title, quote } = person;

          let position = "nextSlide";
          if (personIndex === index) {
            position = "activeSlide";
          }
          if (
            personIndex === index - 1 ||
            (index === 0 && personIndex === people.length - 1)
          ) {
            position = "lastSlide";
          }

          return (
            <article className={position} key={id}>
              <img src={image} alt={name} className="person-img" />
              <h4>{name}</h4>
              <p className="title">{title}</p>
              <p className="text">{quote}</p>
              <FaQuoteRight className="icon" />
            </article>
          );
        })}
        <button className="prev" onClick={() => setIndex(index - 1)}>
          <FiChevronLeft />
        </button>
        <button className="next" onClick={() => setIndex(index + 1)}>
          <FiChevronRight />
        </button>
      </div>
    </section>
  );
}

export default App;
